export const handleExperienceDropdown = () => {
  const buttons = document.querySelectorAll('.wp-block-valve-experience-data__buttons button')

  if (buttons) {
    buttons.forEach(button => {
      const postID = button.dataset.postId
      const dropdownClass = `.js-dropdown-${postID}`
      const dropdown = document.querySelector(dropdownClass)

      button.addEventListener('click', function () {
        toggleDropdown(dropdown)
      })
    })
  }
}

export const toggleDropdown = ( dropdown ) => {
    const isHidden = dropdown.classList.contains('hidden')

    if (isHidden) {
    // Show dropdown
      dropdown.style.maxHeight = `${dropdown.scrollHeight + 40}px`
    } else {
    // Hide dropdown
      dropdown.style.maxHeight = null
    }

  dropdown.classList.toggle('hidden');
}


handleExperienceDropdown()

